module.exports = __webpack_public_path__ + "static/media/yt-robot-dance.bf218dec.mov";